import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

import { OddsDisplayFormat } from '@frontend/sports/types/models/user-settings';

import { NumpadService } from '../../../../../lib/numpad/numpad.service';
import { LINEAR_CONTAINER_STAKE_SERVICE } from '../../../stake/services/digital/linear/linear-container-stake.interface';
import { LINEAR_CONTAINER_SUMMARY_SERVICE } from '../../../summary/services/linear/linear-container-summary.interface';
import { TeaserBetContainerStakeService } from '../../services/linear/teaser-bet-container-stake.service';
import { TeaserBetContainerSummaryService } from '../../services/linear/teaser-bet-container-summary.service';

@Component({
    selector: 'bs-teaser-bet-linear-summary',
    templateUrl: './teaser-bet-linear-summary.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        NumpadService,
        { provide: LINEAR_CONTAINER_SUMMARY_SERVICE, useClass: TeaserBetContainerSummaryService },
        { provide: LINEAR_CONTAINER_STAKE_SERVICE, useClass: TeaserBetContainerStakeService },
    ],
    standalone: false,
})
export default class TeaserBetLinearSummaryComponent {
    @HostBinding('class') className = 'teaser-bet-linear-summary';

    @Input() oddsDisplayFormat: OddsDisplayFormat;
    @Input() teaserText: string;
}
